import { css, html, LitElement, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { cardStyles } from '../../styles';
import { arrowRight } from '../../svg';

@customElement('umb-market-pointer-card')
export class UmbMarketPointerCard extends LitElement {
  @property({ type: Object })
  icon?: TemplateResult = arrowRight;

  @property({ type: Object })
  query?: { [key: string]: any };

  @property({ type: String })
  text?: string;

  @property({ type: Boolean })
  static = false;

  connectedCallback() {
    super.connectedCallback();

    this.text = this.query
      ? `Explore all ${this.query._queryType} packages`
      : 'Explore all';
  }

  render() {
    if (this.static) {
      return html`<a href="/all/${this.query?._queryType}">
        <small>${this.text}</small></a
      >`;
    }
    return html`<a class="card" href="/all/${this.query?._queryType}">
      <div class="card-body">
        <h3>${this.text}</h3>
        <div class="image-wrapper">${this.icon}</div>
      </div>
    </a>`;
  }

  static styles = [
    cardStyles,
    css`
      :host {
        --dominant-color-opaque: transparent;
      }

      .card {
        background-color: var(--uui-color-default);
        color: white;
      }
      .card:not(.single):hover {
        background-color: var(--uui-color-default);
        color: white;
      }

      a {
        text-decoration: none;
      }

      a:hover {
        --svg-fill: var(--uui-color-current);
        --svg-stroke: var(--grey);
      }

      .card-body {
        justify-content: center;
        align-items: center;
      }

      .image-wrapper {
        width: 100px;
        height: 100px;
        background:transparent;
      }

      svg {
        width: 100px;
        height: 100px;
        --fill: var(--uui-color-surface);
      }

      h3 {
        font-size: 26px;
        overflow: unset;
        line-height: 1.2;
        text-align: center;
        margin: var(--l-spacer) auto;
      }

      :host([standalone]) .image-wrapper,
      :host([standalone]) svg {
        display: none;
      }

      :host([standalone]) {
        display: flex;
        padding:0;
        justify-content:start;
      }

      :host([standalone]) .card {
        width: auto;
        border:none;
        background:transparent;
        color: var(--uui-color-default);
      }

      :host([standalone]) .card:hover {
        box-shadow:none;
      }

      :host([standalone]) .card-body {
        flex-direction: row;
        padding: var(--s-spacer);
        transform:translateX(calc(var(--s-spacer) * -1));
      }

      :host([standalone]) h3 {
        margin: 0 var(--xs-spacer) 0 0;
        font-size: 20px;
        font-weight: normal;
      }
    `,
  ];
}
